module.exports = __webpack_public_path__ + "static/img/3s-info-4.9329780.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/3s-info-4.png
// module id = NTse
// module chunks = 0